module.exports = __webpack_public_path__ + "static/media/bethIcon.b75831c8.png";